import { __ } from "@wordpress/i18n";
import { useBlockProps, InnerBlocks } from "@wordpress/block-editor";

export default function save({ attributes }) {
	const blockProps = useBlockProps.save();
	return (
		<div {...blockProps} title={attributes.title}>
			<InnerBlocks.Content />
		</div>
	);
}
